import styled from 'styled-components';
import { styledHeader, Typography } from './BaseTypes';
import { styledMargin } from '../layout/Margin';

export const H5 = styled.h5<Typography>`
  ${styledHeader}
  ${styledMargin}
  font-size: 20px;
`;
